import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {usePath} from 'hooks';
import {PATHS} from 'routes/constants';
import Page from 'components/Page';
import {EsimInfoCard} from './components/EsimInfoCard/EsimInfoCard';
import {EsimActionsCard} from './components/EsimActionsCard';

function ManageEsimView() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  const onBackClick = () => {
    navigate(getFullPath(PATHS.home), {replace: true});
  };

  return (
    <Page
      title={t('esim.plans')}
      subtitle={t('esim.manage.title')}
      navBarTitle={t('esim.plans')}
      onBackButtonClick={onBackClick}
      hideSubPanelBackButton={true}
      isSubHeaderVisible
    >
      <div className="flex flex-col gap-12 max-w-[25rem]">
        <EsimActionsCard />
        <EsimInfoCard />
      </div>
    </Page>
  );
}

export {ManageEsimView};
